import { render, staticRenderFns } from "./ReferralReopenForm.vue?vue&type=template&id=2f144006&scoped=true&"
import script from "./ReferralReopenForm.vue?vue&type=script&lang=ts&"
export * from "./ReferralReopenForm.vue?vue&type=script&lang=ts&"
import style0 from "./ReferralReopenForm.vue?vue&type=style&index=0&id=2f144006&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f144006",
  null
  
)

export default component.exports